export default {
  type: 'newsletter',
  aliases: ['newsletter'],
  slices: [{
    name: 'newsletter_subscription_form',
    path: 'Newsletter/SubscriptionForm.vue'
  }]
};